import { render, staticRenderFns } from "./PaymentLedger.vue?vue&type=template&id=564aa413&"
import script from "./PaymentLedger.vue?vue&type=script&lang=js&"
export * from "./PaymentLedger.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLedger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports